import { render, staticRenderFns } from "./TelegramCampaignForPartners.vue?vue&type=template&id=63f3b8aa&"
import script from "./TelegramCampaignForPartners.vue?vue&type=script&lang=js&"
export * from "./TelegramCampaignForPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports